/* eslint-disable */
const getters = {
  getBrands(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
  getBrandCategoriesTree(state) {
    return state.brandCategories.tree;
  },
};

export default getters;
